import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ManagePlayroomsPage } from './admin//pages/manage-playrooms/manage-playrooms.page';
import { ManageUsersPage } from './admin//pages/manage-users/manage-users.page';
import { ManageVisitorsPage } from './admin//pages/manage-visitors/manage-visitors.page';
import { AdminSettingsPage } from './admin//pages/admin-settings/admin-settings.page';
import { VisitsPage } from './admin//pages/visits/visits.page';
import { AdminGuard } from './admin/guards/admin.guard';
import { LoggedOutGuard } from './admin/guards/logged-out.guard';
import { AdminManagerGuard } from './admin/guards/adminmanager.guard';
import { EmployeeGuard } from './admin/guards/employee.guard';
import { LoggedInGuard } from './admin/guards/logged-in.guard';
import { ManageVisitsComponent } from './admin//pages/manage-visits/manage-visits.component';
import { ManageRampsPage } from './admin//pages/manage-ramps/manage-ramps.page';
import { AdminComponent } from './admin/admin.component';
import { RegistrationComponent } from './registration/registration.component';
import { SelectRoomPage } from './registration/pages/select-room/select-room.page';
import { RegisterPage } from './registration/pages/register/register.page';
import { GroupRegistrationPage } from './registration/pages/group-registration/group-registration.page';
import { LandingPage } from './registration/pages/landing/landing.page';
import { ConsentComponent } from './registration/consent/consent/consent.component';
import { ConsentGroupVisitComponent } from './registration/consent-group-visit/consent-group-visit.component';
import { LoginPage } from './admin/pages/login/login.page';
import { RegistrationLoginPage } from './registration/pages/login/login.page';
import { RegistrationAdminGuard } from './registration/guards/admin.guard';
import { RegistrationLoggedOutGuard } from './registration/guards/logged-out.guard';
import { RegistrationLoggedInGuard } from './registration/guards/logged-in.guard';
import { OnlineRegistrationComponent } from './registration/pages/online-registration/online-registration/online-registration.component';
import { OnlineConsentComponent } from './registration/pages/online-registration/online-consent/online-consent.component';
import { ManageStaffcardsComponent } from './admin/pages/manage-staffcards/manage-staffcards/manage-staffcards.component';
import { AppTextPrivacyPolicyComponent } from './registration/pages/app-text-privacy-policy/app-text-privacy-policy.component';
import { AppTextOnlinePrivacyPolicyComponent } from './registration/pages/app-text-online-privacy-policy/app-text-online-privacy-policy.component';
import { KarticaVisitoraPage } from './admin/pages/kartica-visitora/kartica-visitora.page';
import { ManageBirthdayZonesPage } from './admin/pages/manage-birthday-zones/manage-birthday-zones.page';
import { TimeSlotConfigurationComponent } from './admin/pages/time-slot-configuration/time-slot-configuration.component';
import { BirthdateBookingComponent } from './admin/pages/birthdate-booking/birthdate-booking.component';
import { BirthdayListPage } from './admin/pages/birthday-list/birthday-list.page';
import { DoplatneKarteReportComponent } from './admin/reports/doplatne-karte-report/doplatne-karte-report.component';

import { AdminManagOperaterGuard } from './admin/guards/adminmanageroperater.guard';
import { AdminOperaterGuard } from './admin/guards/adminoperator.guard';
import { CallListComponent } from './admin/pages/call-list/call-list.component';
import { VisitorsCardFromBookingComponent } from './admin/pages/visitors-card-from-booking/visitors-card-from-booking.component';
import { BirthdayDetailsComponent } from './admin/pages/birthday-details/birthday-details.component';
import { BirthdayEditFormFromCalendarComponent } from './admin/pages/birthday-edit-form-from-calendar/birthday-edit-form-from-calendar.component';
import { PonovljeniRodjendaniReportComponent } from './admin/reports/ponovljeni-rodjendani-report/ponovljeni-rodjendani-report.component';
import { ProsecanUzrastDetetaIgraonicaIzvestajComponent } from './admin/reports/prosecan-uzrast-deteta-igraonica-izvestaj/prosecan-uzrast-deteta-igraonica-izvestaj.component';
import { ListaPozivaOperateriReportComponent } from './admin/reports/lista-poziva-operateri-report/lista-poziva-operateri-report.component';
import { ZakazaniRodjendaniOperateriReportComponent } from './admin/reports/zakazani-rodjendani-operateri-report/zakazani-rodjendani-operateri-report.component';
import { ActivityLogComponent } from './admin/activity-log.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'admin/manage-playrooms',
    pathMatch: 'full'
  },
  {
    path: 'admin',
    component: AdminComponent,
    children: [
      {
        path: 'login',
        component: LoginPage,
        canActivate: [LoggedOutGuard]
      },
      {
        path: 'manage-visits',
        component: VisitsPage,
        canActivate: [EmployeeGuard]
      },
      {
        path: 'manage-playrooms',
        component: ManagePlayroomsPage,
        canActivate: [AdminGuard]
      },
      {
        path: 'manage-visitors',
        component: ManageVisitorsPage,
        canActivate: [AdminManagOperaterGuard]
      },
      {
        path: 'manage-users',
        component: ManageUsersPage,
        canActivate: [AdminManagerGuard]
      },
      {
        path: 'profile-settings',
        component: AdminSettingsPage,
        canActivate: [LoggedInGuard]
      },
      {
        path: 'time-slot-configuration',
        component: TimeSlotConfigurationComponent,
        canActivate: [LoggedInGuard]
      },
      {
        path: 'visits',
        component: ManageVisitsComponent,
        canActivate: [AdminManagerGuard]
      },
      {
        path: 'manage-ramps',
        component: ManageRampsPage,
        canActivate: [AdminGuard]
      },
      {
        path: 'kartica-visitora/:id',
        component: KarticaVisitoraPage,
        canActivate: [AdminManagOperaterGuard]
      },
      {
        path: 'visitors-card-from-booking',
        component: VisitorsCardFromBookingComponent,
        canActivate: [AdminManagOperaterGuard]
      },
      {
        path: 'kartica-visitora',
        component: KarticaVisitoraPage,
        canActivate: [AdminManagOperaterGuard]
      },
       {
        path: 'birthday-edit-from-form-calendar',
        component: BirthdayEditFormFromCalendarComponent,
        canActivate: [AdminManagOperaterGuard]
      },
      {
        path: 'manage-staffcards',
        component: ManageStaffcardsComponent,
        canActivate: [AdminGuard]
      },
      {
        path: 'activity-log',
        component: ActivityLogComponent,
        canActivate: [AdminGuard]
      },
      {
        path: 'manage-birthday-zones',
        component: ManageBirthdayZonesPage,
        canActivate: [AdminGuard]
      },
      {
        path: 'birthday-booking/:roomId/:zoneId',
        component: BirthdateBookingComponent,
        canActivate: [AdminGuard]
      },
      {
        path: 'birthday-booking',
        component: BirthdateBookingComponent,
        canActivate: [AdminManagOperaterGuard]
      },
      {
        path: 'birthday-list',
        component: BirthdayListPage,
        canActivate: [AdminOperaterGuard]
      },
      {
        path: 'call-list',
        component: CallListComponent,
        canActivate: [AdminOperaterGuard]
      },
      {
        path: 'birthday-details/:visitorId/birthdays/:birthdayId',
        component: BirthdayDetailsComponent,
        canActivate: [AdminManagOperaterGuard]
      },
       {
        path: 'repetdBirthdayReport',
        component: PonovljeniRodjendaniReportComponent,
        canActivate: [AdminManagerGuard]
      },
      {
        path: 'averageBirthDayReport',
        component: ProsecanUzrastDetetaIgraonicaIzvestajComponent,
        canActivate: [AdminManagerGuard]
      },
      {
        path: 'callListStatsReport',
        component: ListaPozivaOperateriReportComponent,
        canActivate: [AdminManagerGuard]
      },
      {
        path: 'jedinstveniPoziviReport',
        component: ListaPozivaOperateriReportComponent,
        data: { reportQuery: true },
        canActivate: [AdminManagerGuard]
      },
      {
        path: 'zakazaniRodjendaniOperateriReport',
        component: ZakazaniRodjendaniOperateriReportComponent,
        canActivate: [AdminManagerGuard]
      },
      {
        path: 'doplatne-karte-report',
        component: DoplatneKarteReportComponent,
        canActivate: [AdminManagerGuard]
      }
    ]
  },
  {
    path: 'registration',
    component: RegistrationComponent,
    children: [
      {
        path: 'select-room',
        component: SelectRoomPage,
        canActivate: [RegistrationAdminGuard]
      },
      {
        path: 'login',
        component: RegistrationLoginPage,
        canActivate: [RegistrationLoggedOutGuard]
      },
      {
        path: 'register',
        component: RegisterPage,
        canActivate: [RegistrationLoggedInGuard]
      },
      {
        path: 'online-registration',
        component: OnlineRegistrationComponent,
      },
      {
        path: 'online-consent',
        component: OnlineConsentComponent,
      },
      {
        path: 'register-group',
        component: GroupRegistrationPage,
        canActivate: [RegistrationLoggedInGuard]
      },
      {
        path: 'home',
        component: LandingPage,
        canActivate: [RegistrationLoggedInGuard]
      },
      {
        path: 'consent',
        component: ConsentComponent,
        canActivate: [RegistrationLoggedInGuard]
      },
      {
        path: 'consent-group-visit',
        component: ConsentGroupVisitComponent,
        canActivate: [RegistrationLoggedInGuard]
      },
      {
        path: 'app-text-privacyPolicy',
        component: AppTextPrivacyPolicyComponent,
      },
      {
        path: 'app-text-online-privacyPolicy',
        component: AppTextOnlinePrivacyPolicyComponent,
      }
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
